import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Arrow",
  "use": "Arrow-usage",
  "viewBox": "0 0 18 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 36\" id=\"Arrow\"><path fill-rule=\"evenodd\" d=\"M0 32.269l10.83-14.27L0 3.731 4.34 0 18 18 4.34 36z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol